import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import s from './Hero.scss';

interface IHeroProps {
    onClick: () => void;
}

export function Hero({ onClick }: IHeroProps) {
	useStyles(s);

	return (
		<div className="sl-teams-hero">
			<div className="sl-teams-hero__left">
				<div className="sl-teams-hero__left__content">
					<div className="sl-teams-hero__left__content__title">
						Tech training your employees love
					</div>
					<div className="sl-teams-hero__left__content__subtitle">
						Equip your people with the latest
						<b> coding, data </b>
						and
						<b> tech skills </b>
						in 5-minute mobile lessons that fit perfectly into
						breaks, commutes and free time.
					</div>
					<div className="sl-teams-hero__left__content__subtitle">
						Lower hiring, onboarding and L&D costs with an engaging,
						rewarding and social learning experience.
					</div>
					<div className="sl-teams-hero__left__content__cta">
						<Button onClick={onClick}>Book your free demo</Button>
					</div>
				</div>
			</div>
			<div className="sl-teams-hero__right">
				<img
					id="hero-image-desktop"
					src="https://blob.sololearn.com/web-assets/teams-hero.png"
					alt="hero"
				/>
				<img
					id="hero-image-mobile"
					src="https://blob.sololearn.com/web-assets/teams-hero-mobile.png"
					alt="hero"
				/>
			</div>
		</div>
	);
}
